export default __webpack_public_path__ + "fonts/403e92cd707af724e872de896364be3c.ttf";